<template>
  <div id="order-ai-container">
    <iframe
      frameborder="1"
      :height="`${height}px`"
      width="100%"
      scrolling="no"
      :src="`${VUE_APP_BASE_AUTH_MODULE}/order/data-order-ai`"
      allow="clipboard-read; clipboard-write"
    />

    <ModalAcceptOrder
      id="modal-acc-order"
      :order="dataOrder"
      @order:accepted="sendMessage('refetch')"
      @order:rejected="sendMessage('refetch')"
    />
    <ModalCheckProofTransfer
      id="check-proof-transfer"
      :url="url"
    />
    <ModalTopUp
      @refreshSaldo="getBalance"
      @handleTopupWithQris="handleTopupWithQris"
    />
    <ScanQRIS
      :qr-bill-detail="dataQris"
      :is-custom="true"
      @paymentSuccess="handlePaymentSuccess"
    />
  </div>
</template>
<script>
import ModalAcceptOrder from '@/views/pages/komship/order/OrderAi/modal/ModalAcceptOrder.vue'
import ModalCheckProofTransfer from './modal/ModalCheckProofTransfer.vue'
import ModalTopUp from '../../customer/Broadcast/components/ModalTopUp.vue'
import ScanQRIS from '../../dashboard/modal/ScanQRIS.vue'

export default {
  components: {
    ModalAcceptOrder,
    ModalCheckProofTransfer,
    ModalTopUp,
    ScanQRIS,
  },
  data() {
    return {
      height: 0,
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
      dataOrder: {},
      url: '',
      dataQris: {},
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      if (event.origin !== this.VUE_APP_BASE_AUTH_MODULE) return

      const {
        type, data, order, link, route,
      } = event.data || {}

      if (type === 'SET_DIMENSION') {
        this.height = Math.floor(data.height) + 150
      }
      if (type === 'ACCEPT_ORDER') {
        this.$bvModal.show('modal-acc-order')
        this.dataOrder = order
      }
      if (type === 'CHECK_PROOF_TRANSFER') {
        this.$bvModal.show('check-proof-transfer')
        this.url = link
      }
      if (type === 'HANDLE_TOP_UP') {
        this.$bvModal.show('modal-top-up-komchat-coin')
      }
      // Tangani perubahan route & filter dari iframe
      // Gunakan history.replaceState agar URL di address bar browser berubah
      // tanpa memicu reload/re-render pada komponen iframe
      if (type === 'route' && route) {
        window.history.replaceState(null, '', route)
      }
    },
    sendMessage(param) {
      const message = {
        refetch: { type: 'REFETCH_GET_ORDER_AI' },
        reset_form: { type: 'RESET_FORM' },
        refetch_balance: { type: 'REFETCH_BALANCE' },
      }
      const iframe = document.querySelector('#order-ai-container iframe')
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(message[param], '*')
      }
    },
    handleTopupWithQris(data) {
      this.dataQris = data
      this.$bvModal.show('scanQris')
    },
    handlePaymentSuccess(message) {
      this.$bvModal.hide('scanQris')
      this.sendMessage('refetch_balance')
      this.$toast_success({ message })
    },
  },
}
</script>
